import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Paywall from "./pages/Paywall/Paywall";
import PaywallV1 from "./pages/Paywall/PaywallV1";
import PaywallV2 from "./pages/Paywall/PaywallV2";
import PaywallV3 from "./pages/Paywall/PaywallV3";
import PaywallHair from "./pages/Paywall/PaywallHair";
import PaywallHairRecommend from "./pages/Paywall/PaywallHairRecommend";
import PaywallHairStyle from "./pages/Paywall/PaywallHairStyle";
import PaywallHairStyleMan from "./pages/Paywall/PaywallHairStyleMan";
import PaywallFaceShape from "./pages/Paywall/PaywallFaceShape";
import PaywallV1_3months_upsell from "./pages/Paywall/PaywallV1_3months_upsell";
import PaywallV1_3months_upsell_v2 from "./pages/Paywall/PaywallV1_3months_upsell_v2";
import PaywallGlassesUpsellV2 from "./pages/Paywall/PaywallGlasses_3months_upsell_v2";
import PaywallSunglassesUpsellV2 from "./pages/Paywall/PaywallSunglasses_3months_upsell_v2";
import PaywallMakeupUpsellV2 from "./pages/Paywall/PaywallMakeup_3months_upsell_v2";
import GetOffer from "./pages/GetOffer/GetOffer";
import GetOfferHair from "./pages/GetOfferHair/GetOfferHair";
import MyIQ from "./pages/MyIQ/MyIQ";
import Clarity from "./pages/Clarity/Clarity";
import RouteRedirectWithSearch from "./components/RouteRedirectWithSearch";
import PaywallAnalyticsRouteTracker from "./components/PaywallAnalyticsRouteTracker";
import ScrollToTop from "./components/ScrollToTop";
import FaceMeshPage from "./pages/FaceMesh/FaceMesh";
import FaceMeshV2Page from "./pages/FaceMesh/FaceMeshV2";
import FaceMeshFaceShapePage from "./pages/FaceMesh/FaceMeshFaceShape";
import FaceMeshHairstylePage from "./pages/FaceMesh/FaceMeshHairstyle";
import FaceMeshHairstyleScratchPage from "./pages/FaceMesh/FaceMeshHairstyleScratch";
import FaceMeshHaircolorPage from "./pages/FaceMesh/FaceMeshHaircolor";
import FaceMeshFaceShapeV2Page from "./pages/FaceMesh/FaceMeshFaceShapeV2";
import FaceMeshHairstyleV2Page from "./pages/FaceMesh/FaceMeshHairstyleV2";
import FaceMeshHaircolorV2Page from "./pages/FaceMesh/FaceMeshHaircolorV2";
import FaceMeshGlassesV2Page from "./pages/FaceMesh/FaceMeshGlassesV2";
import FaceMeshSunglassesV2Page from "./pages/FaceMesh/FaceMeshSunglassesV2";
import FaceMeshMakeupV2Page from "./pages/FaceMesh/FaceMeshMakeupV2";
import ScratchHairstylePage from "./pages/FaceMesh/ScratchHairstyle";

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <PaywallAnalyticsRouteTracker />
        <div className="bg-[var(--funnel-cs-bg)] text-[var(--funnel-cs-ink)]">
          <Routes>
            <Route path="/" element={<Paywall />} />
            {/* New canonical colortype routes (keep old in parallel) */}
            <Route path="/colortype-3month-29" element={<PaywallV1 />} />
            <Route path="/colortype-3month-29-upsell" element={<PaywallV1_3months_upsell useUserPhotoHero />} />
            <Route path="/colortype-3month-29-upsell-v2" element={<PaywallV1_3months_upsell_v2 />} />
            <Route path="/colortype-1month-29" element={<PaywallV3 />} />
            <Route path="/glasses-3month-29-upsell-v2" element={<PaywallGlassesUpsellV2 />} />
            <Route path="/sunglasses-3month-29-upsell-v2" element={<PaywallSunglassesUpsellV2 />} />
            <Route path="/makeup-3month-29-upsell-v2" element={<PaywallMakeupUpsellV2 />} />
            {/* New canonical haircolor/hairstyle routes (keep old in parallel) */}
            <Route path="/haircolor-3month-29" element={<PaywallHair useUserPhotoHero />} />
            <Route path="/haircolor-recomend-3month-29" element={<PaywallHairRecommend useUserPhotoHero />} />
            <Route path="/hairstyle-3month-29-woman" element={<PaywallHairStyle useUserPhotoHero />} />
            <Route path="/hairstyle-3month-29-woman-exp-userphoto" element={<RouteRedirectWithSearch to="/hairstyle-3month-29-woman" />} />
            <Route path="/bodytype-3month-29-woman" element={<PaywallHairStyle />} />
            <Route path="/wedding-guest-3month-29-woman" element={<PaywallHairStyle />} />
            <Route path="/hairstyle-3month-29-man" element={<PaywallHairStyleMan />} />
            {/* New canonical faceshape routes (copy of /hairstyle for iteration) */}
            <Route path="/faceshape-3month-29" element={<PaywallFaceShape useUserPhotoHero />} />
            <Route path="/faceshape_3month_29" element={<PaywallFaceShape />} />
            {/* Legacy paths kept for migration */}
            <Route path="/v1" element={<PaywallV1 />} />
            <Route path="/v2" element={<PaywallV2 />} />
            <Route path="/month" element={<PaywallV3 />} />
            <Route path="/hair" element={<PaywallHair />} />
            <Route path="/hairstyle" element={<PaywallHairStyle />} />
            <Route path="/hairstyle-man" element={<PaywallHairStyleMan />} />
            <Route path="/v1_3months_upsell" element={<PaywallV1_3months_upsell />} />
            <Route path="/getoffer" element={<GetOffer />} />
            <Route path="/getofferhair" element={<GetOfferHair />} />
            <Route path="/myiq" element={<MyIQ />} />
            <Route path="/clarity" element={<Clarity />} />
            <Route path="/facemesh" element={<FaceMeshPage />} />
            <Route path="/facemesh-v2" element={<FaceMeshV2Page />} />
            <Route path="/facemesh-faceshape" element={<FaceMeshFaceShapePage />} />
            <Route path="/facemesh-faceshape-v2" element={<FaceMeshFaceShapeV2Page />} />
            <Route path="/facemesh-hairstyle" element={<FaceMeshHairstylePage />} />
            <Route path="/facemesh-hairstyle-scratch" element={<FaceMeshHairstyleScratchPage />} />
            <Route path="/facemesh-hairstyle-v2" element={<FaceMeshHairstyleV2Page />} />
            <Route path="/facemesh-hairstyle-v2-ab-userphoto" element={<RouteRedirectWithSearch to="/facemesh-hairstyle-v2" />} />
            <Route path="/facemesh-haircolor" element={<FaceMeshHaircolorPage />} />
            <Route path="/facemesh-haircolor-v2" element={<FaceMeshHaircolorV2Page />} />
            <Route path="/facemesh-glasses-v2" element={<FaceMeshGlassesV2Page />} />
            <Route path="/facemesh-sunglasses-v2" element={<FaceMeshSunglassesV2Page />} />
            <Route path="/facemesh-makeup-v2" element={<FaceMeshMakeupV2Page />} />
            <Route path="/scratch-hairstyle" element={<ScratchHairstylePage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
